export const DEADLINE_PROPERTY_MAP = {
  app_deadline: "formattedApplicationDeadline",
  application: "formattedApplicationDeadline",
  registration: "formattedEnrollmentDeadline",
  reg_deadline: "formattedEnrollmentDeadline",
  enrollment: "formattedEnrollmentDeadline",
} as const;

export type TDeadlineKey = keyof typeof DEADLINE_PROPERTY_MAP;

export const APPLY_NOW_URL = "/apply-now";
